import CustomTableWithColors from "./CustomTableWithColors.jsx";

export default CustomTableWithColors;



// WEBPACK FOOTER //
// ./src/components/pages/Create_portfolio_by_Advisor/model_portfolio/customTableWithColors/index.js